import { configureStore } from '@reduxjs/toolkit';
import authReducer from './redux/AuthSlice';
import userReducer from './redux/UsersSlice';
import reportedPostsReducer from './redux/ReportedPostsSlice';
import summaryReducer from './redux/SummarySlice'
import applicantReducer from './redux/ApplicantSlice';
import adminReducer from './redux/AdminSlice';
import attributesReducer from './redux/AttributesSlice'
import healthFacilitiesReducer from './redux/HealthFacilitiesSlice';
import jobsReducer from './redux/JobsSlice';
import jobCategoriesReducer from './redux/JobCategoriesSlice';
import jobApplicationsReducer from './redux/JobApplicationsSlice';
import eventsReducer from './redux/EventSlice';
import trainingProgramReducer from './redux/TrainingProgramsSlice';
import alumniReducer from './redux/AlumniSlice'
// import departmentReducer from './Redux/DepartmentSlice'

const store = configureStore({
    reducer:{
        auth:authReducer,
        users:userReducer,
        reportedPosts: reportedPostsReducer,
        summary:summaryReducer,
        applicants:applicantReducer,
        admins: adminReducer,
        attributes:attributesReducer,
        healthFacilities: healthFacilitiesReducer,
        jobs: jobsReducer,
        jobCategories:jobCategoriesReducer,
        jobApplications: jobApplicationsReducer,
        events: eventsReducer,
        trainingPrograms: trainingProgramReducer,
        alumni: alumniReducer
        // departments: departmentReducer
    }
})

export default store;